// ════════════════════════════════════════════════════════════════════
//  SEO של הדפים הציבוריים — מקור אמת יחיד לכותרת, לתיאור ולכתובת הקנונית.
//  משמש גם את prerender-seo.js (ה-HTML הסטטי שנוצר בזמן build) וגם את <Seo>
//  שבדפים, כך שמה שגוגל קורא ב-HTML זהה למה שהאפליקציה מציבה אחרי הטעינה.
// ════════════════════════════════════════════════════════════════════

// title = הכותרת בלי הסיומת " | חשבית" (היא מתווספת אוטומטית).
export const SEO_PAGES = {
  "/features": {
    title: "תכונות: חשבוניות, קבלות, דרישות תשלום ובוט וואטסאפ",
    description:
      "כל מה שחשבית מציעה: חשבונית מס, קבלה, דרישת תשלום עם תזכורות אוטומטיות, הצעת מחיר, חתימה דיגיטלית, מספרי הקצאה, סריקת קבלות והפקה מהוואטסאפ.",
  },
  "/pricing": {
    title: "מחירים — תוכנה להפקת חשבוניות, מתחילים בחינם",
    description:
      "מסלולי חשבית — התחילו בחינם והפיקו חשבוניות וקבלות ללא הגבלה. מסלול עסקי מתקדם בתשלום חודשי נוח.",
  },
  "/articles": {
    title: "מדריכים לעצמאים: חשבוניות, קבלות, מע״מ ועוסק פטור",
    description:
      "מדריכים בשפה פשוטה על חשבונית מס, קבלה, דרישת תשלום, מספר הקצאה, דיווח מע״מ ופתיחת עוסק פטור — מאת חשבית.",
  },
  "/about": {
    title: "אודות — מערכת ישראלית להפקת חשבוניות לעסקים קטנים",
    description:
      "הסיפור שמאחורי חשבית — כלים פשוטים ומקצועיים להנהלת חשבונות לכל עסק בישראל, תואמים רשות המסים.",
  },
  "/contact": {
    title: "צור קשר — שאלות ותמיכה בהפקת חשבוניות",
    description: "יש שאלה על חשבית? נשמח לעזור — צרו איתנו קשר ונחזור אליכם בהקדם.",
  },
  "/terms": {
    title: "תנאי שימוש",
    description: "תנאי השימוש בשירות חשבית להנהלת חשבונות והפקת חשבוניות.",
  },
  "/privacy": {
    title: "מדיניות פרטיות",
    description:
      "מדיניות הפרטיות של חשבית בהתאם לחוק הגנת הפרטיות ותיקון 13: איזה מידע נאסף, למה הוא משמש, למי הוא מועבר ומהן הזכויות שלכם.",
  },
  "/security": {
    title: "אבטחת מידע",
    description: "הצפנה מתקדמת, גיבויים אוטומטיים ובקרות גישה — כך חשבית שומרת על הנתונים שלכם.",
  },
  "/verify": {
    title: "אימות מסמך",
    description: "אמתו את האותנטיות של מסמך שהונפק בחשבית באמצעות קוד האימות הדיגיטלי שלו.",
  },
  "/accessibility": {
    title: "הצהרת נגישות",
    description:
      "הצהרת הנגישות של חשבית — מחויבות להנגשת האתר לפי תקן ישראלי IS 5568 ו-WCAG 2.0 AA, אמצעי נגישות, ופנייה לרכז הנגישות.",
  },
};

// הכתובת הקנונית של דף. דפים שנוצרים כקובץ סטטי (dist/<נתיב>/index.html) —
// הדפים שלמעלה וכל המאמרים — השרת מגיש בכתובת עם "/" בסוף (/pricing → 301 →
// /pricing/), ולכן זו הכתובת הקנונית שלהם. בלי זה ה-canonical הצביע על כתובת
// שמפנה חזרה לדף עצמו, וגוגל קיבל אות סותר. שאר הנתיבים נשארים כמו שהם.
export function canonicalPath(path) {
  if (!path || path === "/") return "/";
  if (path.endsWith("/")) return path;
  return path in SEO_PAGES || path.startsWith("/articles/") ? `${path}/` : path;
}
